import { render, staticRenderFns } from "./orderCreatePR.vue?vue&type=template&id=36f27b69&scoped=true"
import script from "./orderCreatePR.vue?vue&type=script&lang=js"
export * from "./orderCreatePR.vue?vue&type=script&lang=js"
import style0 from "./orderCreatePR.vue?vue&type=style&index=0&id=36f27b69&prod&lang=css"
import style1 from "./orderCreatePR.vue?vue&type=style&index=1&id=36f27b69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f27b69",
  null
  
)

export default component.exports